import { getEnrollmentHistoryUrl } from 'automation-ui-canvas/utils/urls';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import BasePaths from 'automation-ui-routing/BasePaths';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import TrackableButton from 'automation-ui-usage-tracking/components/TrackableButton';
import { useHistory, useLocation } from 'react-router-dom';
import { jsx as _jsx } from "react/jsx-runtime";
const EnrollmentDiagnosisButton = ({
  flowObjectTypeId,
  flowId
}) => {
  const history = useHistory();
  const {
    search
  } = useLocation();
  return /*#__PURE__*/_jsx(TrackableButton, {
    size: "small",
    use: "tertiary",
    onClick: () => {
      history.replace({
        pathname: `${getEnrollmentHistoryUrl({
          flowId
        })}/${BasePaths.ENROLLMENT_DIAGNOSE}`,
        search
      });
    },
    trackableKey: Trackables.OPENED_DIAGNOSE_ENROLLMENT_PANEL,
    marginBlockStart: "100",
    marginBlockEnd: "400",
    children: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
      baseLangKey: "automation.enrollmentHistory.panel.selected-enrollment.enrollmentDiagnoseButton.title_cob",
      objectTypeId: flowObjectTypeId
    })
  });
};
export default EnrollmentDiagnosisButton;